import { useEffect } from 'react';

const BASE_TITLE = 'Kudu';

/**
 * Set the document title. With no argument the title is the bare brand
 * ("Kudu"); with a section name it becomes "Kudu <name>" (e.g. "Kudu
 * Humanities"). The default lives in index.html; pages that want a named title
 * call this hook.
 */
export function useDocumentTitle(name?: string): void {
  useEffect(() => {
    const trimmed = name?.trim();
    document.title = trimmed ? `${BASE_TITLE} ${trimmed}` : BASE_TITLE;
  }, [name]);
}
